export default "__VITE_ASSET__Ch3k84N2__"